<template>
  <div class="container single-product">
    <div v-if="isProductLoaded">
      <div
        class="navigation d-none d-lg-flex justify-content-start align-items-center"
      >
        <nav aria-label="breadcrumb" v-if="hasBreadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">
                {{ $t("items.home") }}
              </router-link>
            </li>
            <li class="breadcrumb-item" v-if="breadcrumb[0]">
              <router-link :to="`/categories/${breadcrumb[0].id}`">
                {{ breadcrumb[0].title }}
              </router-link>
            </li>
            <li class="breadcrumb-item" v-if="breadcrumb[1]">
              <router-link
                :to="{
                  path: `/categories/${breadcrumb[0].id}`,
                  query: { brand: computedBrand },
                }"
              >
                {{ breadcrumb[1].title }}
              </router-link>
            </li>
            <li class="breadcrumb-item" v-if="breadcrumb[2]">
              <router-link
                :to="{
                  path: `/categories/${breadcrumb[2].id}/variants`,
                }"
              >
                {{ breadcrumb[2].title }}
              </router-link>
            </li>
            <li class="breadcrumb-item" v-if="myProduct.product.title">
              <div>
                {{ myProduct.product.title }}
              </div>
            </li>
          </ol>
        </nav>
        <nav aria-label="breadcrumb" v-if="hasCategories && !hasBreadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">{{ $t("items.home") }}</router-link>
            </li>
            <li
              class="breadcrumb-item"
              v-for="(link, index) in categories"
              :key="index"
            >
              <router-link :to="`/categories/${link.id}`">{{
                link.title
              }}</router-link>
            </li>
          </ol>
        </nav>
      </div>

      <b-row align-h="center" class="mt-5">
        <b-col cols="12" md="4" class="slider p-0">
          <div
            class="ribbon ribbon-top-left"
            :class="{ 'long-rebbon': isLongDealType }"
            v-if="hasDealType"
          >
            <span :class="{ 'long-rebbon-span': isLongDealType }">{{
              dealTypeDisplay
            }}</span>
          </div>
          <Slider :myProduct="myProduct"></Slider>
        </b-col>
        <b-col cols="12" md="8" class="product-info">
          <ProductInfo
            :myProduct="myProduct"
            :lastCategory="lastCategory"
            @filerDynamicInputs="filerDynamicInputs"
            :loading="loading"
          ></ProductInfo>
        </b-col>
      </b-row>
      <div class="humhum-tabs mt-5">
        <b-tabs content-class="mt-3">
          <b-tab :title="$t('singleProduct.specsTitle')" active>
            <Specs :myProduct="myProduct" v-if="myProduct"></Specs>
          </b-tab>
          <b-tab :title="$t('singleProduct.ratingHeader')">
            <Rating :myProduct="myProduct" v-if="myProduct"></Rating>
          </b-tab>
        </b-tabs>
      </div>
      <section class="my-4">
        <div class="humhum-tabs">
          <b-tabs content-class="mt-3">
            <b-tab :title="$t('singleProduct.otherSuppliers')" active>
              <suppliersTab :thirdCatID="thirdCatId" />
            </b-tab>
            <b-tab :title="$t('items.relativeProducts')">
              <div
                class="most-sold text-center related-products"
                v-if="hasSupplierProducts"
              >
                <div class="my-5 py-5">
                  <VueSlickCarousel
                    v-bind="settings"
                    v-if="hasSupplierProducts"
                  >
                    <div
                      class="p-4"
                      v-for="item in filteredSupplierProducts"
                      :key="item.id"
                    >
                      <Product :data="item"></Product>
                    </div>
                  </VueSlickCarousel>
                </div>
              </div>
              <div v-else>
                <h3>{{ $t("home.noDataTill") }}</h3>
              </div>
            </b-tab>
            <b-tab :title="$t('singleProduct.relatedOffers')">
              <relatedOffers />
            </b-tab>
          </b-tabs>
        </div>
      </section>
    </div>
    <div v-else-if="isProductLoading">
      <LoadingScreen></LoadingScreen>
    </div>
    <div
      class="d-flex justify-content-center align-items-center flex-column p-5 notFound"
      v-if="notFound"
    >
      <h2>{{ $t("profile.notFound") }}</h2>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Slider from "@/components/single-product/Slider.vue";
import ProductInfo from "@/components/single-product/ProductInfo.vue";
import Specs from "@/components/single-product/Specs.vue";
import Rating from "@/components/single-product/Rating.vue";
import Product from "@/components/pages/supplier/products/Product.vue";
import categories from "@/services/categories";
import suppliers from "@/services/suppliers";
import suppliersTab from "@/components/single-product/SuppliersTab.vue";
import relatedOffers from "@/components/relatedOffers";
import LoadingScreen from "@/components/global/LoadingScreen.vue";

export default {
  name: "SingleProduct",
  metaInfo: {
    title: "single product data",
    titleTemplate: "%s",
    htmlAttrs: {
      lang: localStorage.getItem("lang"),
      amp: true,
    },
  },
  components: {
    Slider,
    ProductInfo,
    Specs,
    Rating,
    Product,
    VueSlickCarousel,
    suppliersTab,
    relatedOffers,
    LoadingScreen,
  },
  data() {
    return {
      id: this.$route.query.id,
      dealType: this.$route.query.type || null,
      loading: false,
      myProduct: null,
      supplierProducts: [],
      supplierProductsId: null,
      notFound: false,
      productCategories: [],
      lastCategory: null,
      firstCat: null,
      secondCat: null,
      thirdCat: null,
      categories: [],
      breadcrumb: [],
      filerDynamicInputsData: null,
      settings: {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1191,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: true,
              dots: false,
            },
          },
          {
            breakpoint: 820,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: true,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
            },
          },
        ],
      },
    };
  },
  computed: {
    isProductLoaded() {
      return this.myProduct !== null && !this.notFound;
    },
    isProductLoading() {
      return this.myProduct === null && !this.notFound;
    },
    hasCategories() {
      return this.categories && this.categories.length > 0;
    },
    hasBreadcrumb() {
      return this.breadcrumb && this.breadcrumb.length > 0;
    },
    computedBrand() {
      return this.breadcrumb[1].title.replace(/ /g, "");
    },
    hasDealType() {
      return !!this.dealType || this.hasBuyGetPromotion;
    },
    hasBuyGetPromotion() {
      return (
        !this.dealType &&
        this.myProduct &&
        this.myProduct.buy_get_promotion_running_by_type &&
        this.myProduct.buy_get_promotion_running_by_type.promotion &&
        this.myProduct.buy_get_promotion_running_by_type.promotion.buy_x
      );
    },
    dealTypeDisplay() {
      if (this.dealType) {
        return this.dealType;
      }
      if (this.hasBuyGetPromotion) {
        return `${this.$t("profile.buy")} ${
          this.myProduct.buy_get_promotion_running_by_type.promotion.buy_x
        } ${this.$t("profile.get")} ${
          this.myProduct.buy_get_promotion_running_by_type.promotion.get_y
        }`;
      }
      return "";
    },
    isLongDealType() {
      return this.dealType
        ? this.dealType.trim().length > 20
        : this.hasBuyGetPromotion &&
            (
              this.myProduct.buy_get_promotion_running_by_type.promotion.buy_x +
              this.myProduct.buy_get_promotion_running_by_type.promotion.get_y
            ).length > 20;
    },
    hasSupplierProducts() {
      return this.supplierProducts && this.supplierProducts.length > 0;
    },
    filteredSupplierProducts() {
      return this.supplierProducts.filter(
        (product) => product.product_details_by_type.quantity >= 1
      );
    },
    thirdCatId() {
      return this.thirdCat && this.thirdCat.id ? this.thirdCat.id : null;
    },
  },
  methods: {
    productDetails() {
      this.loading = true;
      categories
        .productDetails(this.id)
        .then((res) => {
          this.myProduct = res.data.items;
          this.supplierProductsId = res.data.items.client_id;
          this.productCategories = res.data.items.product.categories || [];
          this.lastCategory = this.productCategories.length
            ? this.productCategories[this.productCategories.length - 1]
            : null;
          this.firstCat = this.productCategories[0] || null;
          this.secondCat = this.productCategories[1] || null;
          this.thirdCat = this.productCategories[2] || null;
          this.categories = this.productCategories;
          this.breadcrumb = res.data.items.breadcrumb || [];
        })
        .catch((err) => {
          if (err.response && err.response.data.code === 404) {
            this.notFound = true;
            this.myProduct = null;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    productDetailsWithDynamicFilters() {
      this.loading = true;
      categories
        .productDetailsWithDynamicFilters(this.id, this.filerDynamicInputsData)
        .then((res) => {
          this.myProduct = res.data.items;
          this.supplierProductsId = res.data.items.client_id;
          this.productCategories = res.data.items.product.categories || [];
          this.lastCategory = this.productCategories.length
            ? this.productCategories[this.productCategories.length - 1]
            : null;
          this.firstCat = this.productCategories[0] || null;
          this.secondCat = this.productCategories[1] || null;
          this.thirdCat = this.productCategories[2] || null;
        })
        .catch((err) => {
          if (err.response && err.response.data.code === 404) {
            this.notFound = true;
            this.myProduct = null;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSupplierProducts() {
      if (!this.supplierProductsId) return;
      suppliers
        .getSupplierProducts(this.supplierProductsId, this.id)
        .then((resp) => {
          this.supplierProducts = resp.data.items.data || [];
        });
    },
    filerDynamicInputs(filerDynamicInputsData) {
      this.filerDynamicInputsData = filerDynamicInputsData;
      this.productDetailsWithDynamicFilters();
    },
  },
  created() {
    this.productDetails();
  },
  mounted() {
    setTimeout(() => {
      this.getSupplierProducts();
    }, 1200);
  },
};
</script>
<style lang="scss">
.humhum-tabs {
  @media (max-width: 992px) {
    padding: 0;
  }
}

.notFound {
  min-height: 70vh;
}

.slick-slide {
  padding: 0 2px;
}

@media (max-width: 992px) {
  .product-info {
    order: 2;
  }

  .slider {
    order: 1;
  }
}

.breadcrumb {
  font-size: 20px;
  margin: 20px 0;
}
.single-product {
  .cr-sticky {
    left: -40% !important;
    text-indent: 13%;
  }
}
.breadcrumb-item{
  display: flex;
  font-weight: bold;
}
</style>
